module.exports = __webpack_public_path__ + "img/sendout-limit.e743aef8.webp";